import React, {
    ReactElement,
} from 'react'
import { StandardPopover } from 'components'
import './CaseHistoryPopover.scss'

interface CaseHistoryPopoverProps {
    anchorEl: null | HTMLElement
    onClose: () => void
    caseInfo: any
    testId?: string
}

const CaseHistoryPopover = ({
    anchorEl,
    onClose,
    caseInfo,
    testId = 'caseHistoryPopover',
}: CaseHistoryPopoverProps): ReactElement => {
    const { mockHistoryData } = caseInfo
    const historyData = mockHistoryData || []

    const handleOnClose = () => {
        onClose()
    }

    return (
        <StandardPopover
            anchorEl={anchorEl}
            onPopoverClose={handleOnClose}
            popoverHeaderTitle={`Case History`}
            testId={testId}
            popoverWidth={650}
            disableScrollLock={true}
            showSecondaryActionBtn={false}
            showPrimaryActionBtn={false}
            anchorOrigin={{ vertical: 'bottom', horizontal: -292 }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <div className={'emp-caseHistoryPopover-tableContainer'}>
                <table className={'emp-caseHistoryPopover-table'}>
                    <thead>
                        <tr>
                            <th className={'emp-caseHistoryPopover-timestampHeader'}>Timestamp</th>
                            <th className={'emp-caseHistoryPopover-actionHeader'}>Action</th>
                            <th className={'emp-caseHistoryPopover-userHeader'}>Username</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyData.map((row: any, index: number) => (
                            <tr key={index} className={'emp-caseHistoryPopover-row'}>
                                <td className={'emp-caseHistoryPopover-timestamp'}>
                                    {row.timestamp}
                                </td>
                                <td className={'emp-caseHistoryPopover-action'}>
                                    {row.action}
                                </td>
                                <td className={'emp-caseHistoryPopover-user'}>
                                    {row.user}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {historyData.length === 0 && (
                    <div className={'emp-caseHistoryPopover-emptyState'}>
                        No history records found.
                    </div>
                )}
            </div>
        </StandardPopover>
    )
}

export default CaseHistoryPopover
